import { subscriptionPingsConstants } from "../constants/subscription_pings_constants";
import { makeDELETERequest, makeGETRequest, makePUTRequest } from "../utils/Axios";

export const subscriptionPingActions = {
    getSubscriptionPing,
    hideSubscriptionPing
}

export function getSubscriptionPing({organization_id, ...props}){
    return function (dispatch) {
        try{
            props?.onBefore?.();
            makeGETRequest(`/api/v1/organizations/${organization_id}/subscription_pings`)
            .then(response => {
                if(response.data.status === "ok"){
                    props?.onSuccess?.(response);
                }else {
                    props?.onError?.(response);
                }
            })
        }catch(e){
            props?.onFailure?.();

            dispatch( {
                type: subscriptionPingsConstants.SUBSCRIPTION_PING_FAILURE,
                payload: console.log(e),
            })
        }finally {
            props.onFinally?.();   
        }
    }
}

export function hideSubscriptionPing({organization_id, ...props}){
    return function (dispatch) {
        try{
            props?.onBefore?.();
            makePUTRequest(`/api/v1/organizations/${organization_id}/subscription_pings/hidden`)
            .then(response => {
                if(response.data.status === "ok"){
                    props?.onSuccess?.(response);
                }else {
                    props?.onError?.(response);
                }
            })
        }catch(e){
            props?.onFailure?.();

            dispatch( {
                type: subscriptionPingsConstants.SUBSCRIPTION_PING_FAILURE,
                payload: console.log(e),
            })
        }finally {
            props.onFinally?.();   
        }
    }
}
